export const baseHref = document.querySelector('base')?.getAttribute('href') || '/';
